import { useNavigate, useLocation } from 'react-router-dom';
import { List, Columns3 } from 'lucide-react';
import { clsx } from 'clsx';

/**
 * List ⇄ board toggle for the "עסקאות" section. The deals list (`/`) and the kanban
 * pipeline (`/pipeline`) are two views of the same data, surfaced as a single nav tab;
 * this segmented control switches between them so they read as one section.
 */
export function DealsViewToggle() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isBoard = pathname.startsWith('/pipeline');

  const base =
    'flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-semibold transition-[color,background-color,transform] active:scale-[0.96]';
  const active = 'bg-[#0C1A55] text-white shadow';
  const inactive = 'text-gray-500 hover:text-gray-700';

  return (
    <div className="inline-flex rounded-xl border border-gray-200 bg-white p-1 shadow-sm">
      <button
        type="button"
        onClick={() => navigate('/')}
        className={clsx(base, !isBoard ? active : inactive)}
        aria-pressed={!isBoard}
      >
        <List size={16} />
        רשימה
      </button>
      <button
        type="button"
        onClick={() => navigate('/pipeline')}
        className={clsx(base, isBoard ? active : inactive)}
        aria-pressed={isBoard}
      >
        <Columns3 size={16} />
        לוח
      </button>
    </div>
  );
}
